(() => {
  const root = document.getElementById('ck-redeem-app');
  if (!root) return;

  const proxy = (root.getAttribute('data-proxy') || '/apps/redeem').replace(/\/$/, '');
  const codeForm = document.getElementById('ck-code-form');
  const checkoutForm = document.getElementById('ck-checkout-form');
  const codeAlert = document.getElementById('ck-code-alert');
  const claimAlert = document.getElementById('ck-claim-alert');
  const reveal = document.getElementById('ck-prize-reveal');
  const success = document.getElementById('ck-claim-success');
  const codeStep = root.querySelector('[data-step="code"]');
  const variantId = root.getAttribute('data-variant-id');
  const productHandle = root.getAttribute('data-product-handle') || 'redemption-prize';

  const state = { claimToken: '', artist: '', title: '' };

  const messages = {
    invalid: 'This code is invalid.',
    redeemed: 'This prize has already been claimed.',
    reserved: 'This code is already being checked out. Try again in a few minutes if checkout was not finished.',
    network: 'Something went wrong. Please try again or contact us.',
    noproduct: 'Redemption checkout is not configured yet. Contact the store.',
  };

  function showAlert(el, type, text) {
    el.classList.remove('ck-hidden', 'ck-alert--error', 'ck-alert--ok');
    el.classList.add(type === 'ok' ? 'ck-alert--ok' : 'ck-alert--error');
    el.textContent = text;
  }

  async function post(path, body) {
    const res = await fetch(`${proxy}${path}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    });
    let data = {};
    try {
      data = await res.json();
    } catch (e) {
      data = {};
    }
    return { res, data };
  }

  async function resolveVariantId() {
    if (variantId && variantId !== '') return variantId;
    if (!window.Shopify) return '';
    const res = await fetch(`/products/${productHandle}.js`);
    if (!res.ok) return '';
    const product = await res.json();
    return String((product.variants && product.variants[0] && product.variants[0].id) || '');
  }

  codeForm.addEventListener('submit', async (event) => {
    event.preventDefault();
    const code = new FormData(codeForm).get('code');
    showAlert(codeAlert, 'ok', 'Checking your code…');
    try {
      const { data } = await post('/verify', { code });
      if (!data.ok) {
        showAlert(codeAlert, 'error', messages[data.error] || messages.invalid);
        return;
      }
      codeAlert.classList.add('ck-hidden');
      codeStep.classList.add('ck-hidden');
      state.claimToken = data.claimToken || '';
      state.artist = data.prize.artist || '';
      state.title = data.prize.title || '';
      document.getElementById('ck-prize-title').textContent = data.prize.title || '';
      document.getElementById('ck-prize-artist').textContent = data.prize.artist || '';
      document.getElementById('ck-prize-description').textContent = data.prize.description || '';
      document.getElementById('ck-prize-auth').textContent = data.prize.authentication || '';
      document.getElementById('ck-claim-token').value = state.claimToken;
      const gallery = document.getElementById('ck-prize-images');
      gallery.innerHTML = '';
      (data.prize.images || []).forEach((img) => {
        const image = document.createElement('img');
        image.src = img.url;
        image.alt = img.alt || data.prize.artist || 'Prize photo';
        gallery.appendChild(image);
      });
      reveal.classList.add('is-visible');
      reveal.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } catch (err) {
      showAlert(codeAlert, 'error', messages.network);
    }
  });

  checkoutForm.addEventListener('submit', async (event) => {
    event.preventDefault();
    if (!state.claimToken) {
      showAlert(claimAlert, 'error', messages.invalid);
      return;
    }

    if (!window.Shopify) {
      reveal.classList.remove('is-visible');
      success.classList.add('is-visible');
      success.querySelector('h2').textContent = 'Preview checkout';
      success.querySelector('p').textContent =
        'On the live store this continues to Shopify checkout at $0 with free prize shipping.';
      success.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }

    showAlert(claimAlert, 'ok', 'Opening checkout…');
    try {
      const id = await resolveVariantId();
      if (!id) {
        showAlert(claimAlert, 'error', messages.noproduct);
        return;
      }
      const cart = await fetch('/cart.js').then((r) => r.json());
      if (cart.item_count > 0) {
        const ok = window.confirm(
          'Checking out your prize only so shipping stays free. Other items in your cart will be removed from this checkout.',
        );
        if (!ok) {
          claimAlert.classList.add('ck-hidden');
          return;
        }
      }
      await fetch('/cart/clear.js', { method: 'POST' });
      const add = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [
            {
              id: Number(id),
              quantity: 1,
              properties: {
                _ck_claim_token: state.claimToken,
                'Prize artist': state.artist,
                'Prize title': state.title,
              },
            },
          ],
        }),
      });
      if (!add.ok) {
        showAlert(claimAlert, 'error', messages.noproduct);
        return;
      }
      window.location.href = '/checkout';
    } catch (err) {
      showAlert(claimAlert, 'error', messages.network);
    }
  });
})();
